import {useSelector} from "react-redux";
import {selectEntityData} from "state/selectors/data";

export function useNodeData(id) {
    return useSelector((s)=>selectEntityData(s, 'db.nodes', id));
}